import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTracking, track } from 'lib/analytics'
import useWindowSize from 'lib/hooks/useWindowSize'
import DrawerModal from 'components/modal/drawer-modal'
import { HeroProductShape } from 'store/lib/prop-types'
import {
  FilterOptions,
  FiltersPanel,
  CollapsedFilterOptions,
} from './components'

export const ProductFilters = ({ products }) => {
  const tracker = useTracking()
  const [initialProducts, setInitialProducts] = useState(products)
  const [showModal, setShowModal] = useState(false)
  const [initialOpenSection, setInitialOpenSection] = useState()
  const { width } = useWindowSize()

  if (products.length > initialProducts.length) {
    // reset initialProducts if there are more in the incoming list
    // ex: user lands on a URL filtered page then clears the filters
    setInitialProducts(products)
  }

  const openPanel = (focusedSection) => {
    setShowModal(true)
    setInitialOpenSection(focusedSection)

    // track panel open
    tracker.trackEvent({
      event: track.filtersPanelToggled,
      // Avo currently validates the focusedSection as one of ['Sort', 'Brand', 'Product Type', 'Rating', 'In Stock', 'Price Range'] if adding a section, please remember to update in Avo as well
      focusedSection,
      isOpen: true,
    })
  }

  const closePanel = () => {
    setShowModal(false)

    // track panel close
    tracker.trackEvent({
      event: track.filtersPanelToggled,
      isOpen: false,
    })
  }

  if (!products) return null

  const trigger =
    width < 930 ? ( // 930px is where the buttons wrap
      <CollapsedFilterOptions products={products} openPanel={openPanel} />
    ) : (
      <FilterOptions products={products} openPanel={openPanel} />
    )

  return (
    <>
      <DrawerModal
        origin="left"
        show={showModal}
        onHide={closePanel}
        trigger={trigger}
      >
        <FiltersPanel
          closePanel={closePanel}
          initialProducts={initialProducts}
          initialOpenSection={initialOpenSection}
        />
      </DrawerModal>
    </>
  )
}

ProductFilters.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape(HeroProductShape)).isRequired,
}
